import React, { useMemo, useState } from "react";
import userImage from "../../assets/user-profile.png";
import { Button } from "../../components/ui/button";
import { FaEye, FaPencilAlt } from "react-icons/fa";
import { ArrowUpDown } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { DataTable } from "../../components/DataTable";
import { membershipService, ServiceOnMount } from "../../services";
import { Skeleton } from "../../components/ui/skeleton";
import ProfileCard from "../../components/ProfileCard";
import Modal from "../../components/Modal";
import ShortenedText from "../../components/ShortenedText";
import { GoPeople } from "react-icons/go";
import dayjs from "dayjs"
import StatusBadge from "../../components/table/StatusBadge"

const columns = [
  {
    accessorKey: "profileId",
    header: "Member ID",
    cell: ({ row }) => <span>{row.getValue("profileId")}</span>,
  },
  {
    accessorKey: "profileName",
    header: "Member Name",
    cell: ({ row }) => <span>{row.getValue("profileName")}</span>,
  },
  {
    accessorKey: "email",
    header: "Email Address",
    cell: ({ row }) => <span>{row.getValue("email")}</span>,
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const status = row.getValue("status");
      return (
        <StatusBadge
          status={status === "Deactivated" && !row.original.verified
            ? "Invitation sent"
            : status}
        />
      );
    },
  },
  {
    accessorKey: "lastLogin",
    header: "Last Login",
    cell: ({ row }) => (
      <span>
        {
          row.getValue("lastLogin")
            ? dayjs(row.getValue("lastLogin")).fromNow()
            : "never"
          // new Date(row.getValue("lastLogin")).toLocaleString()
        }
      </span>
    ),
  },
];

const ViewGroupDetails = () => {
  const navigate = useNavigate();
  const { groupId } = useParams();
  const [activeTab, setActiveTab] = useState("general");
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const actions = (row) => [
    {
      label: "View Details",
      icon: <FaEye />,
      onClick: () => {
        setSelectedMember(row); // Pass the row data as the selected member
        setShowViewModal(true); // Open the modal
      },
      variant: "dropPlain",
    },
  ];

  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
  };

  const statusMap = {
    A: "Active",
    U: "Suspended",
    P: "Pending",
  };

  const dataMap = (item) => ({
    profileId: item?.profile?._id || "N/A",
    profileName: item?.profile?.name || "N/A",
    email: item?.entity?.email || "N/A",
    status: statusMap[item?.profile?.status] || "N/A",
    lastLogin: item?.entity?.last_login
      ? new Date(item.entity.last_login).toLocaleString()
      : "N/A",
    groupName: item?.group?.name || "N/A",
    dateCreated: item?.create_date
      ? new Date(item.create_date).toLocaleDateString()
      : "N/A",
    dateUpdated: item?.last_update
      ? new Date(item.last_update).toLocaleDateString()
      : "N/A",
    groupId: item?.group?._id || "N/A",
    groupLeader: item?.group?.leaders?.length
      ? item.group.leaders.join(", ")
      : "N/A",
  });

  const [reload, setReload] = useState(false);

  const getGroups = ServiceOnMount(
    () => membershipService.getMembersByGroup(groupId),
    dataMap,
    [reload]
  );

  const profileMap = useMemo(() => {
    if (!getGroups.data || getGroups.data.length === 0) return null; // Wait until data is available

    const map = {};
    getGroups.data.forEach((member) => {
      if (member.profileId !== "N/A") {
        map[member.profileId] = member.profileName;
      }
    });
    return map;
  }, [getGroups.data]);
  // return (
  //   <div className="flex flex-col md:flex-row min-h-screen bg-gray-100">
  //     <div className="flex-1 flex flex-col">
  //       <div className="p-8 flex flex-col">
  //         <div className="bg-white shadow p-4 rounded-lg">
  //           <div className="flex justify-between items-center mb-6">
  //             <div className="flex items-center gap-4">
  //               <div className="flex items-center justify-center w-16 h-16 bg-indigo-500 rounded-full shrink-0">
  //                 <GoPeople className="text-white w-12 h-12 p-2" />
  //               </div>
  //               <div>
  //                 <h1 className="text-lg font-semibold text-[#111827]">
  //                   Pending Request
  //                 </h1>
  //                 <hr />
  //                 <div className="mt-6 flex space-x-8">
  //                   <div>
  //                     <div className="text-sm font-semibold text-[#6B7280]">
  //                       Group ID
  //                     </div>
  //                     <div className="text-sm text-[#111827]">
  //                       {getGroups.loading ? (
  //                         <Skeleton className="w-24 h-5" />
  //                       ) : getGroups.data.length > 0 ? (
  //                         getGroups.data[0].groupId
  //                       ) : (
  //                         "N/A"
  //                       )}
  //                     </div>
  //                   </div>
  //                   <div>
  //                     <div className="text-sm font-semibold text-[#6B7280]">
  //                       Date Created
  //                     </div>
  //                     <div className="text-sm text-[#111827]">
  //                       {getGroups.loading ? (
  //                         <Skeleton className="w-28 h-5" />
  //                       ) : getGroups.data.length > 0 ? (
  //                         getGroups.data[0].dateCreated
  //                       ) : (
  //                         "N/A"
  //                       )}
  //                     </div>
  //                   </div>
  //                   <div>
  //                     <div className="text-sm font-semibold text-[#6B7280]">
  //                       Date Updated
  //                     </div>
  //                     <div className="text-sm text-[#111827]">
  //                       {getGroups.loading ? (
  //                         <Skeleton className="w-28 h-5" />
  //                       ) : getGroups.data.length > 0 ? (
  //                         getGroups.data[0].dateUpdated
  //                       ) : (
  //                         "N/A"
  //                       )}
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>

  //             <div className="flex gap-4">
  //               <Button
  //                 onClick={() => navigate(`/group-management/edit/${groupId}`)}
  //               >
  //                 <FaPencilAlt />
  //                 Edit
  //               </Button>
  //             </div>
  //           </div>
  //         </div>

  //         {/* Tabs Section */}
  //         <div className="flex">
  //           <button
  //             onClick={() => handleTabSwitch("general")}
  //             className={`relative mt-5 rounded-tl-xl px-3 pr-10 py-3 text-[14px] font-bold ${
  //               activeTab === "general"
  //                 ? "text-[#111827] bg-white"
  //                 : "text-[#14B8A6] bg-[#F0FDFA]"
  //             }`}
  //             style={{
  //               clipPath: "polygon(0 0, 70% 0, 100% 100%, 0% 100%)",
  //             }}
  //           >
  //             General Info
  //           </button>
  //         </div>

  //         {/* Details Section */}
  //         {activeTab === "general" && (
  //           <div className="grid grid-cols-2 text-sm gap-8 bg-white shadow rounded-lg rounded-t-none p-6">
  //             <div>
  //               {[
  //                 {
  //                   label: "Group Name",
  //                   value: (
  //                     <div className=" text-[#111827]">
  //                       {getGroups.loading ? (
  //                         <Skeleton className="w-28 h-5" />
  //                       ) : getGroups.data.length > 0 ? (
  //                         getGroups.data[0].groupName
  //                       ) : (
  //                         "N/A"
  //                       )}
  //                     </div>
  //                   ),
  //                 },
  //               ].map((item, index) => (
  //                 <div
  //                   key={item.label}
  //                   className={`flex py-3 ${
  //                     index % 2 === 0 ? "bg-gray-100" : "bg-white"
  //                   }`}
  //                 >
  //                   <div className="w-1/3 font-semibold text-gray-600">
  //                     {item.label}
  //                   </div>
  //                   <div className="w-2/3 text-gray-900">{item.value}</div>
  //                 </div>
  //               ))}
  //             </div>
  //             <div>
  //               {[
  //                 {
  //                   label: "Group Leader",
  //                   value: (
  //                     <div className="text-[#111827]">
  //                       {getGroups.loading || !profileMap ? ( // Ensure data is available before processing
  //                         <Skeleton className="w-28 h-5" />
  //                       ) : getGroups.data.length > 0 ? (
  //                         getGroups.data[0].groupLeader
  //                           .split(", ")
  //                           .map((leaderId) => profileMap[leaderId] || leaderId)
  //                           .join(", ")
  //                       ) : (
  //                         "N/A"
  //                       )}
  //                     </div>
  //                   ),
  //                 },
  //               ].map((item, index) => (
  //                 <div
  //                   key={item.label}
  //                   className={`flex py-3 ${
  //                     index % 2 === 0 ? "bg-gray-100" : "bg-white"
  //                   }`}
  //                 >
  //                   <div className="w-1/3 font-semibold text-gray-600">
  //                     {item.label}
  //                   </div>
  //                   <div className="w-2/3 text-gray-900">{item.value}</div>
  //                 </div>
  //               ))}
  //             </div>

  //             <div className="col-span-2 gap-8 bg-white shadow border rounded-lg p-6">
  //               <h1 className="text-lg pb-4 font-semibold">
  //                 Group Members List
  //               </h1>
  //               <hr />
  //               <div className="overflow-x-auto w-full max-w-screen-lg">
  //                 {getGroups.loading ? (
  //                   <div className="flex justify-center items-center py-6">
  //                     <div className="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
  //                     <span className="ml-2 text-gray-600">
  //                       Loading Groups...
  //                     </span>
  //                   </div>
  //                 ) : (
  //                   <DataTable
  //                     columns={columns}
  //                     data={getGroups.data}
  //                     actions={actions}
  //                     disableCheckboxes={true}
  //                   />
  //                 )}
  //               </div>
  //             </div>
  //           </div>
  //         )}
  //       </div>
  //     </div>

  //     {/* View Modal */}
  //     {showViewModal && (
  //       <Modal
  //         isOpen={showViewModal}
  //         onClose={() => setShowViewModal(false)}
  //         title="View Member Details"
  //         description="Below are the details of the selected member."
  //       >
  //         {/* Member ID, Date Created, Date Updated */}
  //         <div className="bg-green-100 p-4 rounded-lg mb-4 grid grid-cols-3 gap-4">
  //           {[
  //             {
  //               label: "Member ID",
  //               value: <ShortenedText text={selectedMember.profileId} />,
  //             },
  //             { label: "Date Created", value: selectedMember?.dateCreated },
  //             { label: "Date Updated", value: selectedMember?.dateUpdated },
  //           ].map((item) => (
  //             <div key={item.label}>
  //               <p className="text-sm font-semibold text-gray-700">
  //                 {item.label}
  //               </p>
  //               <p className="text-base text-gray-900">
  //                 {selectedMember ? (
  //                   item.value
  //                 ) : (
  //                   <Skeleton className="w-20 h-5" />
  //                 )}
  //               </p>
  //             </div>
  //           ))}
  //         </div>

  //         {/* Status, Username, Email, Profile */}
  //         <div className="text-left">
  //           {[
  //             { label: "Status", value: selectedMember?.status },
  //             { label: "User Name", value: selectedMember?.profileName },
  //             { label: "User Email", value: selectedMember?.email },
  //             {
  //               label: "Profile",
  //               value: selectedMember ? (
  //                 <ProfileCard
  //                   name={selectedMember.profileName}
  //                   profileId={
  //                     <ShortenedText text={selectedMember.profileId} />
  //                   }
  //                   dateCreated={selectedMember.dateCreated}
  //                   variant="teal"
  //                 />
  //               ) : (
  //                 <Skeleton className="w-32 h-6" />
  //               ),
  //             },
  //           ].map((item, index) => (
  //             <div
  //               key={item.label}
  //               className={`flex justify-between px-4 py-2 ${
  //                 index % 2 === 0 ? "bg-gray-100" : "bg-white"
  //               }`}
  //             >
  //               <p className="text-sm font-semibold text-gray-700">
  //                 {item.label}
  //               </p>
  //               <div className="text-base text-gray-900">
  //                 {selectedMember ? (
  //                   item.value
  //                 ) : (
  //                   <Skeleton className="w-24 h-5" />
  //                 )}
  //               </div>
  //             </div>
  //           ))}
  //         </div>
  //       </Modal>
  //     )}
  //   </div>
  // );
};

export default ViewGroupDetails;
